import { WhereToBuyProps } from '@design-system/where-to-buy';

import { BodyRenderExternalData } from '~/components/BodyRender/models';

export const whereToBuyMapper = (
  uid: string,
  _currentPageUid,
  { whereToBuyData }: BodyRenderExternalData
): WhereToBuyProps => ({
  ...whereToBuyData,
  componentUid: uid,
});
